/**
 * @ignore
 * Created by daletan on 8/7/16.
 */

'use strict';

const currencyActionConstants = require('../constants/currencyActionConstants.es');
const loginActions = require('../actions/loginActions.es');
const priceHelpers = require('../utils/priceHelpers.es');

const PriceStore = {
    storeName: 'PriceStore',
    initialState: {
        fullProfile: {},
        currency: null,
        model: null,
        canRequestNetPrice: false
    },
    reducers: {
        [loginActions.ACTION_NET_PRICE](state, { userCanRequestNetPrice }) {
            return Object.assign({}, state, {
                canRequestNetPrice: userCanRequestNetPrice
            });
        },
        [currencyActionConstants.CURRENCY_CHANGED](state, { currency }) {
            return Object.assign({}, state, { currency });
        },
        [loginActions.ACTION_FULL_PROFILE](state, { profile }) {
            return Object.assign({}, state, {
                fullProfile: typeof profile.toJSON === 'function' ? profile.toJSON() : profile
            });
        }
    },
    getters: {
        processPrice: (state, itemModel) => {
            const { fullProfile, currency, canRequestNetPrice } = state;
            const {
                salePriceData = {},
                netPriceData = {},
                retailPriceData = {},
                originalPriceData = {} } = priceHelpers.processPriceData({ userProfile: fullProfile, itemModel, currency });
            const itemProps = {
                canRequestNetPrice,
                salePriceData,
                netPriceData,
                retailPriceData,
                originalPriceData
            };
            const ctas = priceHelpers.getButtonOptions({ userProfile: fullProfile, currency, itemModel, itemProps });
            const priceDisplays = priceHelpers.getPriceDisplayOptions({ userProfile: fullProfile, currency, itemModel, itemProps });
            return Object.assign({}, state, {
                ctas,
                priceDisplays,
                salePriceData,
                netPriceData,
                retailPriceData,
                originalPriceData
            });
        }
    }
};

module.exports = PriceStore;



// WEBPACK FOOTER //
// ./assets/js/global/stores/PriceStore.es.js